module.exports = __webpack_public_path__ + "img/数据大屏2.8c6a2378.png";